import { SenderConfiguration } from '@/features/senders/types/sender.types';

export interface SenderConfigInfo {
  status: 'configured' | 'not-configured';
  label: string;
  color: 'success' | 'warning' | 'neutral' | 'error';
  priority: number | null;
  sender?: {
    name: string;
    email: string;
    isVerified: boolean;
  };
}

export const getSenderConfigInfo = (
  config?: SenderConfiguration
): SenderConfigInfo => {
  if (!config) {
    return {
      status: 'not-configured',
      label: 'Non configuré',
      color: 'neutral',
      priority: null,
    };
  }

  const priorityLabels: Record<number, string> = {
    0: 'Défaut',
    1: 'Domaine',
    2: 'Dossier',
  };

  const getColor = (
    config: SenderConfiguration
  ): 'success' | 'warning' | 'error' => {
    if (!config.isActive) return 'warning';
    if (!config.sender.isVerified) return 'error';
    return 'success';
  };

  return {
    status: 'configured',
    label: priorityLabels[config.priority] || 'Inconnu',
    color: getColor(config),
    priority: config.priority,
    sender: {
      name: config.sender.name,
      email: config.sender.email,
      isVerified: config.sender.isVerified,
    },
  };
};

export const getActiveSenderConfig = (
  senderConfigurations?: SenderConfiguration[]
): SenderConfiguration | null => {
  if (!senderConfigurations || senderConfigurations.length === 0) {
    return null;
  }

  // Retourner la première configuration (la plus récente/active)
  // En théorie, il ne devrait y en avoir qu'une seule par domaine/dossier
  return senderConfigurations[0];
};

export const getPriorityLabel = (priority: number): string => {
  const labels: Record<number, string> = {
    0: 'Défaut',
    1: 'Domaine',
    2: 'Dossier',
  };

  return labels[priority] || 'Inconnu';
};

export const getPriorityColor = (priority: number): string => {
  const colors: Record<number, string> = {
    0: 'bg-neutral-100 text-neutral-800 border-neutral-200',
    1: 'bg-primary-100 text-primary-800 border-primary-200',
    2: 'bg-success-100 text-success-800 border-success-200',
  };

  return (
    colors[priority] || 'bg-neutral-100 text-neutral-800 border-neutral-200'
  );
};
